// R1.5 - the server swaps min/max (seniority, per-title experience) on save
// when both are set and min > max. Null / empty / zero values are preserved,
// so they never trigger the hint.
export const RANGE_SWAP_HINT = 'הערכים יוחלפו אוטומטית בשמירה'

function present (v) {
  if (v === null || v === undefined || v === '') return null
  const n = Number(v)
  return isNaN(n) || n === 0 ? null : n
}

export function rangeWillSwap (min, max) {
  const a = present(min)
  const b = present(max)
  return a !== null && b !== null && a > b
}
